import { useEffect, useRef, useCallback } from "react";

interface UseInfiniteScrollOptions {
    onLoadMore: () => void;
    isLoading: boolean;
    hasMore: boolean;
    threshold?: number;
}

export const useInfiniteScroll = ({
    onLoadMore,
    isLoading,
    hasMore,
    threshold = 0.1
}: UseInfiniteScrollOptions) => {
    const sentinelRef = useRef<HTMLDivElement>(null);

    const handleIntersection = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries;

            if (entry && entry.isIntersecting && !isLoading && hasMore) {
                onLoadMore();
            }
        },
        [onLoadMore, isLoading, hasMore]
    );

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, {
            threshold
        });

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [handleIntersection]);

    return sentinelRef;
};
